<template>
  <div class="eaAreaSurveyTemporary">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        <!-- 物业区域概况 -->
        投诉处理概况
      </span>
      <!-- <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>-->
    </div>
    <div class="container">
      <div class="box">
        <div class="AreaSurvey">
          <div class="charts">
            <div ref="eaarea" style="width:420px;height:250px"></div>
            <!-- <div
              @click="forwordtoQueryOrganMge(3,2)"
              ref="generalMeeting"
              style="width:210px;height:150px"
            ></div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { HomePageExControllerSvr } from '@/service/HomePageExControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      arrayData: {
        OverComplaints: [],
        NoOverComplaints: [],
        CantonNmae: []
      },
      areaProtoy: {}
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.HomePageExControllerSvr = new HomePageExControllerSvr();
  },
  mounted() {
    this.getComplaintsSituation();
  },
  methods: {
    getComplaintsSituation() {
      this.HomePageExControllerSvr.GetComplaintsSituation(this.token).then(
        res => {
          for (const {
            OverComplaints: overComplaints,
            NoOverComplaints: noOverComplaints,
            CantonNmae: cantonNmae
          } of res) {
            this.arrayData.OverComplaints.push(overComplaints);
            this.arrayData.NoOverComplaints.push(noOverComplaints);
            this.arrayData.CantonNmae.push(cantonNmae);
          }
          //  this.arrayData.OverComplaints = [10,20,30,40,50,60,70,80,90,100]
          //       this.arrayData.NoOverComplaints = [10,20,30,40,50,60,70,80,90,100]
          //            this.arrayData.CantonNmae.length = 10
          this.drawVote(
            this.$refs.eaarea,
            '已处理的投诉',
            this.arrayData.OverComplaints,
            this.arrayData.NoOverComplaints,
            this.arrayData.CantonNmae,
            '#ffb11a'
          );
        }
      );
    },
    getdata() {
      this.HomeControllerSvr.GetEaAreaGenSit(this.token).then(res => {
        this.areaProtoy = res;
        // this.$nextTick(() => {
        const arr1 = [this.areaProtoy.areaCount, this.areaProtoy.ownerCount];
        const arr2 = [this.areaProtoy.areaCount, this.areaProtoy.reaCount];
        this.drawVote(this.$refs.eaarea, '已处理的投诉', arr2, '#ffb11a');
        // });
      });
    },
    forwordtoQueryOrganMge(value, type) {
      this.$router.push({
        path: 'queryOrganMge',
        query: {
          children: value,
          paramType: type
        }
      });
    },
    forwordAlltoarea() {
      this.$router.push({
        path: 'queryPropertyArea'
      });
    },
    forwordtoarea() {
      this.$router.push({
        path: 'queryPropertyArea',
        query: {
          option: 2
        }
      });
    },
    jumpMore() {
      this.$router.push({ path: 'queryPropertyArea' });
    },
    drawVote(
      dom,
      name,
      OverComplaints,
      NoOverComplaints,
      CantonNmae,
      color,
      option
    ) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      let partNum = 0;
      // info.CandidateItems._Items.forEach(item => {
      //   partNum += 1;
      // });
      //let percentage = Math.round(partNum / totlNum * 100) + '%';
      // let percentage;
      // if (parseInt(data[1]) >= 0 && parseInt(data[0]) >= 0) {
      //   if (parseInt(data[0]) === 0) {
      //     percentage = '0%';
      //   } else {
      //     percentage =
      //       (parseInt(data[1]) / parseInt(data[0]) * 100).toFixed(0) + '%';
      //   }
      // } else {
      //   percentage = '0%';
      // }

      // //如果大于0不到1%的显示<1%
      // if (
      //   parseInt(data[1]) / parseInt(data[0]) * 100 > 0 &&
      //   parseInt(data[1]) / parseInt(data[0]) * 100 < 1
      // ) {
      //   percentage = '<'+'1%';
      // }
      myChartSatisfaction.setOption({
        dataZoom: [
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 100,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            type: 'slider',
            show: true,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 12,
            height: '70%',
            handleSize: 8,
            showDataShadow: false,
            left: '93%'
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // data: ['丰县','沛县','铜山县','睢宁县','邳州市','新沂市','鼓楼区','云龙区','贾汪区','泉山区','九里区'],
          data: CantonNmae,
          axisLabel: {
            interval: 0, //横轴信息全部显示
            rotate: -30 //-15度角倾斜显示
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '未处理',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              normal: { color: '#DB7093' }
            },
            label: {
              normal: {
                show: true,
                position: ''
              }
            },
            data: NoOverComplaints
          },
          {
            name: '已处理',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              normal: { color: '#00BFFF' }
            },
            label: {
              normal: {
                show: true,
                position: ''
              }
            },
            data: OverComplaints
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.eaAreaSurveyTemporary {
  background: #fff;
  .container {
    height: 260px;
    .box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .AreaSurvey {
        .title {
          position: relative;
          padding-left: 15px;
          font-size: 14px;
          &::after {
            position: absolute;
            left: 8px;
            top: 2px;
            content: '';
            width: 4px;
            height: 10px;
            background: #0f77f2;
          }
        }
        .info-text {
          display: flex;
          .info-first,
          .info-second {
            .text {
              margin-top: 10px;
              padding-left: 8px;
              padding-right: 2px;
              font-size: 12px;
              line-height: 14px;
              .num {
                font-size: 13px;
                font-weight: bold;
                color: #0f77f2;
                float: right;
                &.warn {
                  color: #ff4546;
                }
              }
              .cursor {
                cursor: pointer;
              }
            }
          }
          .info-first {
            width: 46%;
            .text {
              border-right: 1px solid #afafaf;
            }
          }
          .info-second {
            width: 54%;
            .text {
              padding-left: 8px;
              text-align: center;
            }
          }
        }

        .charts {
          display: flex;
          justify-content: center;
          .typeTitle {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            min-width: 200px;
            justify-content: space-around;
            .fontSize {
              display: block;
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: -1px;
              color: #333333;
            }
            .num {
              margin-top: 6px;
              display: block;
              text-align: center;
              margin-right: 3px;
              &.warn {
                color: #ff4546;
              }
            }
          }
        }
        .compared {
          height: 230px;
          padding: 10px;
          .chartBox {
            // border-top: 1px solid #e2e2e2;
            padding-top: 10px;
            .tableInfo {
              margin-top: 12px;
              padding-left: 10px;
              display: flex;
              font-size: 12px;
              color: #333;
              .num {
                font-weight: bold;
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: #e2e2e2;
      }
    }
  }
}
</style>